<div class="divage-title">X Character Set – SWIFT Character Set</div>

<p>Computer-based terminals communicating with SWIFT use EBCDIC code. The character set is as follows:</p>

<span>a b c d e f g h i j k l m n o p q r s t u v w x y z</span><br>
<span>A B C D E F G H I J K L M N O P Q R S T U V W X Y Z</span><br>
<span>0 1 2 3 4 5 6 7 8 9</span><br>
<span>/ – ? : ( ) . , ‘ + CrLf Space</span><br>
